import Auth from '@modules/auth/defs/routes';
import Users from '@modules/users/defs/routes';
import Therapists from '@modules/therapists/defs/routes';
import Permissions from '@modules/permissions/defs/routes';
import Notifications from '@modules/notifications/defs/routes';
import Account from '@modules/account/defs/routes';
import Leads from '@modules/leads/defs/routes';
import Help from '@modules/help/defs/routes';
import Admin from '@modules/admin/defs/routes';

const Common = {
  Home: '/',
  NotFound: '/404',
  Pro: '/pro',
};

const Routes = {
  Common,
  Auth,
  Permissions,
  Users,
  Therapists,
  Notifications,
  Account,
  Leads,
  Help,
  LP: '/lp',
  Admin,
  SystemX: '/systemx',
};

export default Routes;
